import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { getCities } from 'models/cities'; // Importing getCities model
import { getTags } from 'models/tags'; // Importing getTags model
import { getPositions } from 'models/positions'; // Importing getPositions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the search agent view.
 */
export default class searchAgentView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo', // Combo box for user name selection
                            id: 'nombre',
                            label: "<span class='icon-user'></span>" + _('Nombre del usuario'), // User name label
                            labelPosition: 'top',
                            container: 'cmb',
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data feed for combo box
                                        this.parse(
                                            webix.ajax(devConfig.geturlApi() + 'Agent/SearchAgent?filter=' + text),
                                        );
                                    },
                                },
                            },
                        },
                        { id: 'grav2', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing the combo box
                },
            ],
        };
        const datos = {
            // Sample data object
            ValorPagar: '1.2426',
            ValorApostado: '1.00',
            PremioProyectado: '1.24',
            Estado: 'Ganador',
            Ganador: 'Si',
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event for clear button
                                this.getRoot().clear();
                                $$('formPagoPremio').hide();
                                $$('tablePagoPremio').hide();
                            },
                        },
                        {
                            view: 'button', // Continue button
                            value: _('Continuar'),
                            id: 'aceptar',
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                // Click event for continue button
                                if (this.getRoot().validate()) {
                                    // Validate form
                                    const filterdata = this.getRoot().getValues(); // Get form values
                                    const vthis = this;
                                    webix.ajax().get(
                                        devConfig.geturlApi() + '/Agent/GetAgentById',
                                        'id=' + $$('nombre').getValue(), // Get agent by ID
                                        {
                                            error: function (text, data, XmlHttpRequest) {
                                                // Error handling
                                                webix.message(_('Error! '));
                                            },
                                            success: function (text, data, XmlHttpRequest) {
                                                // Success handling
                                                text = JSON.parse(text);
                                                vthis.app.callEvent(
                                                    'agentForm:data',
                                                    [text.data], // Call event with agent data
                                                );
                                                $$('formPagoPremio').show(); // Show payment form
                                            },
                                        },
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };
        return {
            view: 'form', // Main view is a form
            scroll: 'y',
            rows: [upper_section, buttons], // Rows contain upper section and buttons
        };
    }

    /**
     * Initializes the view.
     */
    init() {
        $$('aceptar').hide(); // Hide continue button initially
        webix.ready(function () {
            if (screen.width < 500) {
                // Responsive behavior
                $$('grav').hide();
                $$('grav2').hide();
            }
        });
        $$('nombre').attachEvent('onChange', function (newv, oldv) {
            // Event for combo box change
            if (newv > 0) {
                $$('aceptar').show(); // Show continue button if value is valid
            }
        });
        this.on(this.app, 'TransferAgentSuccess', (premio) => {
            // Event for successful agent transfer
            this.getRoot().clear();
            $$('aceptar').hide(); // Hide continue button
            $$('nombre').setValue(''); // Reset combo box value
        });
    }
}

// FILE DOCUMENTED
